<script>
import { Tooltip } from "bootstrap";
import { slideToggle } from "@/composables/slideToggle";

export default {
  props: {
    isClosedButton: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      // Propiedad reactiva para manejar el estado del colapso
      isCollapsed: false,
    };
  },
  mounted() {
    // expand tooltip
    new Tooltip(this.$refs.expandToggler, {
      title: "Maximizar / Minizar",
      placement: "bottom",
      trigger: "hover",
      container: "body",
    });

    // expand
    this.$refs.expandToggler.onclick = (e) => {
      e.preventDefault();

      const target = e.currentTarget.closest(".panel"); // Usar e.currentTarget
      const targetClass = "panel-expand";

      if (
        document.body.classList.contains(targetClass) &&
        target.classList.contains(targetClass)
      ) {
        target.removeAttribute("style");
        target.classList.remove(targetClass);
        document.body.classList.remove(targetClass);
      } else {
        document.body.classList.add(targetClass);
        target.classList.add(targetClass);
      }

      window.dispatchEvent(new Event("resize"));
    };

    // collapse tooltip
    const collapseTooltip = new Tooltip(this.$refs.collapseToggler, {
      title: "Colapsar / Expandir",
      placement: "bottom",
      trigger: "hover",
      container: "body",
    });

    // collapse
    this.$refs.collapseToggler.onclick = (e) => {
      e.preventDefault();

      collapseTooltip.hide();
      slideToggle(
        e.currentTarget.closest(".panel").querySelector(".panel-body")
      ); // Usar e.currentTarget

      // Cambiar el estado reactivo de isCollapsed
      this.isCollapsed = !this.isCollapsed;

      // Emitir el evento personalizado
      this.$emit("collapseToggled");
    };

    // remove tooltip
    new Tooltip(this.$refs.removeToggler, {
      title: "Eliminar",
      placement: "bottom",
      trigger: "hover",
      container: "body",
    });

    // remove
    this.$refs.removeToggler.onclick = (e) => {
      e.preventDefault();

      document.querySelector(".tooltip").remove();
      e.currentTarget.closest(".panel").remove(); // Usar e.currentTarget
    };

    // reload tooltip
    const reloadTooltip = new Tooltip(this.$refs.reloadToggler, {
      title: "Recargar",
      placement: "bottom",
      trigger: "hover",
      container: "body",
    });

    // reload
    this.$refs.reloadToggler.onclick = (e) => {
      e.preventDefault();
      if (reloadTooltip) {
        reloadTooltip.hide();
      }
      const target = e.currentTarget.closest(".panel"); // Usar e.currentTarget
      if (!target.classList.contains("panel-loading")) {
        const targetBody = target.querySelector(".panel-body");
        const spinnerHtml = document.createElement("div");
        spinnerHtml.classList.add("panel-loader");
        spinnerHtml.innerHTML = '<span class="spinner spinner-sm"></span>';
        target.classList.add("panel-loading");
        targetBody.appendChild(spinnerHtml);

        setTimeout(() => {
          target.classList.remove("panel-loading");
          target.querySelector(".panel-loader").remove();
        }, 2000);
      }
    };
  },
};
</script>

<template>
  <div class="panel-heading-btn">
    <a
      href="javascript:;"
      class="btn btn-xs btn-icon btn-primary"
      ref="expandToggler"
    >
      <i class="fa fa-expand"></i>
    </a>
    <a
      href="javascript:;"
      class="btn btn-xs btn-icon btn-success"
      ref="reloadToggler"
    >
      <i class="fa fa-redo"></i>
    </a>
    <a
      href="javascript:;"
      class="btn btn-xs btn-icon btn-warning"
      ref="collapseToggler"
    >
      <i :class="isCollapsed ? 'fa fa-plus' : 'fa fa-minus'"></i>
    </a>
    <a
      v-show="isClosedButton"
      href="javascript:;"
      class="btn btn-xs btn-icon btn-danger"
      ref="removeToggler"
    >
      <i class="fa fa-times"></i>
    </a>
  </div>
</template>
